/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import MenuItem from "@mui/material/MenuItem";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import ClearIcon from "@mui/icons-material/Clear";

// Material Dashboard 2 React examples
import DataTable from "examples/Tables/DataTable";

// Data
import data from "layouts/dashboard/components/Projects/data";
import useDashboard from "hooks/useDashboard";
import MDButton from "components/MDButton";
import { IconButton, InputAdornment, Select } from "@mui/material";
import useTerritory from "hooks/useTerritory";
import { useNavigate } from "react-router-dom";
function Projects() {
  const navigate = useNavigate();
  const { getDealersPerformance } = useDashboard();
  const { getTerritoryOptions } = useTerritory();
  const { columns, rows } = data();
  const [selectedOption, setSelectedOption] = useState("");
  const [territoryOption, setTerritoryOption] = useState([]);

  const handleChange = (event) => {
    event.preventDefault();
    setSelectedOption(event.target.value);
    getDealersPerformance({ territory: event.target.value });
  };
  useEffect(() => {
    getTerritoryOptions().then((res) => {
      if (res.success) {
        const formattedOptions = res.data.map(({ _id, name }) => ({
          label: name,
          value: _id,
        }));
        setTerritoryOption(formattedOptions);
      }
    });
  }, []);
  return (
    <Card>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
        <MDBox>
          <MDTypography variant="h6" gutterBottom>
            Top 5 Dealers
          </MDTypography>
        </MDBox>
        <MDBox display="flex" alignItems="center" gap="2">
          <Select
            value={selectedOption}
            onChange={handleChange}
            fullWidth
            variant="outlined"
            displayEmpty
            sx={{ height: "40px", width: "200px", marginRight: "10px" }}
            endAdornment={
              <InputAdornment position="end">
                {selectedOption ? (
                  <IconButton
                    onClick={() => {
                      setSelectedOption("");
                      getDealersPerformance();
                    }}
                    edge="end"
                  >
                    <ClearIcon />
                  </IconButton>
                ) : (
                  <UnfoldMoreIcon />
                )}
              </InputAdornment>
            }
          >
            <MenuItem value="" disabled>
              Select a territory
            </MenuItem>
            {territoryOption.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          <MDButton color={"info"} onClick={() => navigate("/top-dealers")}>
            view More
          </MDButton>
        </MDBox>
      </MDBox>
      <MDBox>
        <DataTable
          table={{ columns, rows }}
          showTotalEntries={false}
          isSorted={false}
          noEndBorder
          entriesPerPage={false}
        />
      </MDBox>
    </Card>
  );
}

export default Projects;
